<template>
  <carousel
    v-if="productGrapes.length"
    class="product-grape carousel--progress-bar"
    :class="{
      'product-grape--has-carousel': productGrapes.length && productGrapes.length > 1
    }"
    :slides-count="productGrapes.length"
    :slides-per-view="1"
    :show-pagination="true"
  >
    <template
      v-for="(productGrape, index) in productGrapes"
      :key="index"
      #[`slide-${index}`]
    >
      <product-content-block
        :show-carousel="showCarousel"
        :headline="productGrape.displayName"
        :subline="productGrape.subtitle"
        :text="productGrape.shortDescription"
        :link1-text="productGrape.linkText"
        :link1-url="productGrape.linkUrl"
        :link2-text="productGrape.linkText2"
        :link2-url="productGrape.linkUrl2"
        :images="productGrape.images"
        type="grape"
      />
    </template>
  </carousel>
</template>

<script lang="ts">
  import {Options, Prop} from 'vue-property-decorator';
  import ProductContentBlock from '../../components/productContentBlock/productContentBlock.vue';
  import productStore from '../../stores/product/ProductStore';
  import type ProductContent from '../../types/ProductContent';
  import Carousel from '../carousel/carousel.vue';
  import {ProductDetailsSectionMixin, ProductDetailsSectionClass} from '../../utilities/vueMixins/productDetailsSectionMixin/productDetailsSectionMixin';

  @Options({
    name: 'product-grape',
    components: {
      ProductContentBlock,
      Carousel,
    },
    mixins: [ProductDetailsSectionMixin]
  })
  export default class ProductGrape extends ProductDetailsSectionClass {
    @Prop({default: false})
    showCarousel: boolean;

    productStore = productStore;

    get productGrapes(): ProductContent[] {
      const hasData = this.productStore.productGrapes.length && this.productStore.productGrapes[0].set !== false;
      this.hideContainer(!hasData);
      return this.productStore.productGrapes;
    }
  }
</script>
